import { ArrowSquareOut } from '@phosphor-icons/react';
import { toast } from 'sonner';
import { Tip } from '~/components/ui/tip';
import { popOutUrl, popOutWindowName, type PopOutKind } from './pop-out';
import { useWindowChrome } from './window-system';

/**
 * FRONT-3164: "Open in its own window", beside Minimize in a chat or Build
 * window's title bar. Opens the conversation in a separate browser window and
 * closes it here, so the same conversation never runs in two places at once
 * (two live copies would compete for the same answer). Only while docked in
 * the app — the pop-out itself has nothing to pop out of.
 */
export function WindowPopOutButton({
  kind,
  id,
  title,
  className,
}: {
  kind: PopOutKind;
  /** The chat's session id, or the Build's session id. Nothing to open yet → no button. */
  id: string | null | undefined;
  title?: string | null;
  className?: string;
}) {
  const chrome = useWindowChrome();
  if (!chrome.docked || !id) return null;
  return (
    <Tip label="Open in its own window">
      <button
        type="button"
        aria-label="Open in its own window"
        data-testid="window-pop-out"
        onClick={() => {
          const opened = window.open(popOutUrl(kind, id, title), popOutWindowName(kind, id), 'popup,width=1000,height=1100');
          if (!opened) {
            toast.error('Your browser blocked the new window. Allow pop-ups for EDDY and try again.');
            return;
          }
          chrome.close();
        }}
        className={
          className ??
          'size-8 inline-flex items-center justify-center rounded-[10px] text-foreground hover:bg-muted transition-colors'
        }
      >
        <ArrowSquareOut size={17} />
      </button>
    </Tip>
  );
}
